export class RSDispatcherEvent
{
	/**
	 * @param {string} eventName
	 */
	constructor(eventName)
	{
		this.eventName = eventName;
		this.callbacks = [];
	}


	/**
	 * @param {function} callback
	 */
	registerCallback(callback)
	{
		this.callbacks.push(callback);
	}


	/**
	 * @param {function} callback
	 */
	unregisterCallback(callback)
	{
		const index = this.callbacks.indexOf(callback);

		if (index > -1)
		{
			this.callbacks.splice(index, 1);
		}
	}


	/**
	 * @param {?Object} data
	 */
	fire(data = null)
	{
		const callbacks = this.callbacks.slice(0);

		callbacks.forEach((callback) => {
			if(data != null) callback(data);
			else callback();
		});
	}
}
